/* global Swiper */

import { getThemeColor } from "../../js/front/components/color-mode-switcher";


/**
 * Sets initial theme color
 */
window.addEventListener( 'load', () => {

	setDatawrapperThemeColor( getThemeColor() );

	document.querySelectorAll( '.b-nanoanalysis-newest' ).forEach( ( block ) => {

		const sliderContainer = block.querySelector( '.b-nanoanalysis-newest__items' );
		const nextButton = block.querySelector( '.swiper-button-next' );
		const prevButton = block.querySelector( '.swiper-button-prev' );

		if ( sliderContainer ) {

			new Swiper( sliderContainer, {
				slidesPerView: 1,
				spaceBetween: 10,
				loop: true,
				grabCursor: true,
				navigation: {
					nextEl: nextButton,
					prevEl: prevButton,
				},
			} );

		}

	} );

} );

document.addEventListener( 'themeChange', ( event ) => {

	setDatawrapperThemeColor( event.detail.theme );

} );


/**
 * Sets Datawrapper iframe theme color within a specific block
 *
 * @param {string} themeColor - The theme color ('light' or 'dark')
 */
export const setDatawrapperThemeColor = ( themeColor ) => {

	/**
	 * Target all instances Datawrapper iframes
	 *
	 * @type {NodeListOf<Element>}
	 */
	const datawrapperIframes = document.querySelectorAll( 'iframe[src*="datawrapper.dwcdn"]' );
	if ( datawrapperIframes.length ) {

		const isDark = ( themeColor === 'dark' );
		datawrapperIframes.forEach( ( iframe ) => {

			const url = new URL( iframe.src );
			const urlSearch = new URLSearchParams( url.search );
			urlSearch.set( 'dark', isDark );
			url.search = urlSearch.toString();
			iframe.src = url.href;

		} );

	}

};
